import React, { useEffect, useState } from "react";
import YearlyCommonDashboard from "../YearlyCommonDashboard/YearlyCommonDashboard";
import { DividentNEFTToCSV } from "../../../../Helpers/APIEndPoints/EndPoints";

const DividentNEFTFileReport = () => {
  return (
    <>
      <YearlyCommonDashboard
        PageName="DividendNEFTFile"
        ExportToExcelUrl={DividentNEFTToCSV}
        UploadExcel={false} // true -> Option for UploadExcel, false -> NO Option for UploadExcel
        ExcelImport={""}
        openModal={""}
      />
    </>
  );
};

export default DividentNEFTFileReport;
